import { Button, Row, Col } from 'reactstrap';
import * as Icon from 'react-feather';

const FormActions = () => {
  return (
    <Row className="mt-3">
      <Col sm="12" className="mt-1 mt-md-0">
        <Button color="success" type="submit">
          <Icon.Save />
        </Button>
      </Col>
    </Row>
  );
};

export default FormActions;
